/**
 * Text input element handling toplabel and suffix logic.
 *
 * Better solution would be https://developer.mozilla.org/en-US/docs/Web/CSS/:placeholder-shown
 */
export default class TextInput {

  /**
   * @type {Object} dom elements
   */
  #dom = {};

  /**
   * @constructor
   * @param {HTMLInputElement} input input element
   */
  constructor(input) {
    this.#dom.element = input.closest('.form-v10__field');
    this.#dom.input = input;
    this.#dom.label = this.#dom.element.querySelector('.form-v10__label');
    this.#dom.input.addEventListener('input', this.toggleStyles.bind(this));
    this.#dom.input.addEventListener('blur', this.toggleStyles.bind(this));
    this.#dom.input.addEventListener('focus', this.toggleStyles.bind(this));
    this.toggleStyles();
  }

  /**
   * Is label shown at top label
   * @returns {boolean} true if label has focus or value or placeholder
   */
  isLabelShowTop() {
    return this.#dom.label.childNodes.length && (document.activeElement === this.#dom.input || this.#dom.input.value.length > 0 || this.#dom.input.placeholder.length > 0 || this.#dom.input.name === 'license');
  }

  /**
   * Toggle styles on or off.
   */
  toggleStyles() {
    const isShowTop = this.isLabelShowTop()
    this.#dom.element.classList.toggle('form-v10__toplabel-suffix', !isShowTop);
  }

  /**
   * Initializes all functionality
   */
  static init() {
    document.querySelectorAll('.form-v10__toplabel input, .form-v10__toplabel textarea').forEach( input => {
      new TextInput(input);
    })

    // This pageshow event listener fixes the issue when browser autofills the form
    // and the input event is not triggered, which causes the label and the input to overlap.
    window.addEventListener('pageshow', () => {
      document.querySelectorAll('.form-v10__toplabel input').forEach( input => {
        const event = new Event('input');
        input.dispatchEvent(event);
      })
    })
  }
}
